
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/debt-consolidated-contracts",
      function () {
        return require("private-next-pages/admin/debt-consolidated-contracts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/debt-consolidated-contracts"])
      });
    }
  